export default "__VITE_ASSET__DBsuwZJH__"